export default "__VITE_ASSET__BZcYPllw__"